import * as React from "react";
import type { SVGProps } from "react";
const SvgTemperature02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="m6.6 13.953.572.82a1 1 0 0 0 .428-.82zm4.8 0h-1a1 1 0 0 0 .333.745zM9 16.4a1 1 0 1 0 0 2v-2m.056 2a1 1 0 1 0 0-2v2m4.144-1h-1A3.2 3.2 0 0 1 9 20.6v2a5.2 5.2 0 0 0 5.2-5.2zM9 21.6v-1a3.2 3.2 0 0 1-3.2-3.2h-2A5.2 5.2 0 0 0 9 22.6zm-4.2-4.2h1c0-1.087.54-2.047 1.372-2.627l-.572-.82-.572-.82A5.2 5.2 0 0 0 3.8 17.4zm6.6-3.447-.667.745c.345.309.727.772 1.017 1.29.296.527.45 1.024.45 1.412h2c0-.856-.317-1.698-.706-2.391a7.2 7.2 0 0 0-1.427-1.801zm0-9.153h-1v9.153h2V4.8zm-4.8 9.153h1V4.798h-2v9.155zM9 2.4v1a1.4 1.4 0 0 1 1.4 1.4h2A3.4 3.4 0 0 0 9 1.4zm0 0v-1c-1.877 0-3.4 1.52-3.4 3.398h2C7.6 4.026 8.226 3.4 9 3.4zm0 15v1h.056v-2H9zM19.2 7.2h-1a1.4 1.4 0 0 1-1.4 1.4v2a3.4 3.4 0 0 0 3.4-3.4zm-2.4 2.4v-1a1.4 1.4 0 0 1-1.4-1.4h-2a3.4 3.4 0 0 0 3.4 3.4zm-2.4-2.4h1a1.4 1.4 0 0 1 1.4-1.4v-2a3.4 3.4 0 0 0-3.4 3.4zm2.4-2.4v1a1.4 1.4 0 0 1 1.4 1.4h2a3.4 3.4 0 0 0-3.4-3.4z"
    />
  </svg>
);
export default SvgTemperature02;
